const LINK_REGEX = /<[^>]*>\s*(\s*;\s*[^()<>@,;:"/[\]?={} \t]+=(([^()<>@,;:"/[\]?={} \t]+)|("[^"]*")))*(,|$)/g;
const PARAM_REGEX = /[^()<>@,;:"/[\]?={} \t]+=(([^()<>@,;:"/[\]?={} \t]+)|("[^"]*"))/g;
const QUOTE_REGEX = /^"|"$/g;

/**
 * @param {String} header
 *
 * @return {Object} mapping between `rel` keys and link objects with `href` property
 */
export default function parseLinkHeader(header) {
  return header.match(LINK_REGEX)
    .reduce((rels, linkMatch) => {
      const linkParts = linkMatch.split(">");
      const href = linkParts[0].substring(1);
      const params = linkParts[1];
      const link = { href };

      params.match(PARAM_REGEX).forEach(paramMatch => {
        const [key, value] = paramMatch.split("=");

        link[key] = value.replace(QUOTE_REGEX, "");
      });

      if (link.rel !== undefined) {
        rels[link.rel] = link;
      }

      return rels;
    }, {});
}
